'use strict';

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _wrapAsyncGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

var HTTP = require('../http');
/**
 *
 * @param {string} url
 * @param {import("../types").HTTPOptions} [options]
 * @returns {{ path: string; content?: AsyncIterable<Uint8Array> }}
 */


var urlSource = function urlSource(url, options) {
  return {
    path: decodeURIComponent(new URL(url).pathname.split('/').pop() || ''),
    content: readURLContent(url, options)
  };
};
/**
 *
 * @param {string} url
 * @param {import("../types").HTTPOptions} [options]
 * @returns {AsyncIterable<Uint8Array>}
 */


function readURLContent(_x, _x2) {
  return _readURLContent.apply(this, arguments);
}

function _readURLContent() {
  _readURLContent = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
    var http, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            http = new HTTP();
            _context.next = 3;
            return _awaitAsyncGenerator(http.get(url, options));

          case 3:
            response = _context.sent;
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(response.iterator()), _awaitAsyncGenerator), "t0", 5);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readURLContent.apply(this, arguments);
}

module.exports = urlSource;